import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Chip } from "@mui/material";
import styles from "../css/InstallationStatusLabel.module.css";
import { InstallationStatus } from "../../../helper/cloudcore/response/models/body";
import { faRotate, faExclamationCircle, faCircleCheck } from "@fortawesome/free-solid-svg-icons";

interface InstallationStatusLabelProps {
    handleInstall: React.MouseEventHandler;
    installationStatus: InstallationStatus;
}

export const InstallationStatusLabel = ({installationStatus, handleInstall}: InstallationStatusLabelProps) => {
    return (
        <Box className={styles.chipContainer} data-testid={"installation-status-label"}>
            <Chip
                data-testid={"installation-status-chip"}
                label={installationStatus === InstallationStatus.SUCCESS ? "Installed Successfully" : "Installation Failed"}
                icon={<FontAwesomeIcon icon={installationStatus === InstallationStatus.SUCCESS ? faCircleCheck : faExclamationCircle} />}
                color={installationStatus === InstallationStatus.SUCCESS ? "success" : "error"}
            />
            <div data-testid={"retry-installation-icon"} onClick={handleInstall} title="Re-Install">
                <FontAwesomeIcon icon={faRotate} size="2x" className={styles.retryIcon}/>
            </div>
        </Box>
    );
}